import React from 'react';
import { Landmark, CheckSquare } from 'lucide-react';

/**
 * Секция дополнительных параметров пенсионного калькулятора
 */
const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-emerald-500" />
        Дополнительные параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Материнский капитал */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeMaternityCapital"
              checked={formData.includeMaternityCapital}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать материнский капитал
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
            Учет маткапитала для направления на пенсионные накопления
          </p>
        </div>

        {/* Региональные доплаты */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeRegionalSupport"
              checked={formData.includeRegionalSupport}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать региональные доплаты
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
            Доплаты до прожиточного минимума в регионе
          </p>
        </div>

        {/* Сельская надбавка */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeRuralBonus"
              checked={formData.includeRuralBonus}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Сельская надбавка
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
            Доплата 25% для проживающих в сельской местности с 30-летним стажем в сельском хозяйстве
          </p>
        </div>

        {/* Профессиональные коэффициенты */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeProfessionalCoefficient"
              checked={formData.includeProfessionalCoefficient}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать профессиональные коэффициенты
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
            Для особых категорий работников (досрочный выход, повышенные коэффициенты и т.д.)
          </p>
        </div>
      </div>

      <div className="mt-4 bg-gray-100 dark:bg-gray-700/30 p-3 rounded-lg">
        <div className="flex items-start">
          <Landmark className="w-5 h-5 text-gray-600 dark:text-gray-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Дополнительные возможности
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              В России действуют различные механизмы повышения пенсионного обеспечения, 
              включая региональные доплаты, сельские надбавки и особые правила для отдельных 
              профессиональных категорий. Используйте эти опции, если они применимы к вашей ситуации.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;